<template>
  <UserForm />
</template>

<script setup>
import UserForm from '../components/UserForm.vue'
</script>